import { render, staticRenderFns } from "./orderFlowRecord.vue?vue&type=template&id=bb59b910&scoped=true&"
import script from "./orderFlowRecord.vue?vue&type=script&lang=js&"
export * from "./orderFlowRecord.vue?vue&type=script&lang=js&"
import style0 from "./orderFlowRecord.vue?vue&type=style&index=0&id=bb59b910&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb59b910",
  null
  
)

export default component.exports